<template>
  <nav class="mobile-tab-bar">
    <router-link
      to="/"
      class="tab-item"
      :class="{ active: $route.path === '/' }"
    >
      <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
      </svg>
      <span class="tab-label">홈</span>
    </router-link>

    <router-link
      to="/properties"
      class="tab-item"
      :class="{ active: $route.path.startsWith('/properties') }"
    >
      <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
      </svg>
      <span class="tab-label">모든현장</span>
    </router-link>

    <router-link
      to="/chat"
      class="tab-item"
      :class="{ active: $route.path === '/chat' }"
    >
      <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
      </svg>
      <span class="tab-label">꾸우챗</span>
    </router-link>

    <router-link
      to="/community"
      class="tab-item"
      :class="{ active: $route.path.startsWith('/community') }"
    >
      <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"/>
      </svg>
      <span class="tab-label">커뮤니티</span>
    </router-link>

    <router-link
      to="/mypage"
      class="tab-item"
      :class="{ active: $route.path.startsWith('/mypage') }"
    >
      <svg class="tab-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
      </svg>
      <span class="tab-label">마이페이지</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: 'MobileTabBar'
}
</script>

<style scoped>
.mobile-tab-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background: white;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: env(safe-area-inset-bottom, 0);
  z-index: 100;
}

.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1;
  height: 100%;
  text-decoration: none;
  color: #94a3b8;
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;
}

.tab-item.active {
  color: #2563eb;
}

.tab-item.disabled {
  color: #cbd5e1;
  cursor: not-allowed;
}

.tab-icon {
  width: 24px;
  height: 24px;
}

.tab-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: -0.02em;
}

/* 큰 화면에서는 숨기기 */
@media (min-width: 1025px) {
  .mobile-tab-bar {
    display: none;
  }
}
</style>
